import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, FormControl, FormLabel, Row} from "react-bootstrap";
import './css/Setting.module.css'
import InfoIcon from "../../../components/InfoIcon";
import {faArrowRotateLeft} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import TimespanInput from "./Inputs/TimespanInput";

const Setting = ({setting, onChange, constraints}) => {

    const [value, setValue] = useState(setting.value)
    const [newValue, setNewValue] = useState(setting.value)

    const isValid = useRef(true);

    const {t} = useTranslation()

    useEffect(() => {
        onChange(setting.key, newValue, isValid.current)
    }, [newValue, setting.key]);

    useEffect(() => {
        setValue(setting.value)
        setNewValue(setting.value)
    }, [setting.value]);

    const getInputForType = (type) => {
        switch (type.toLowerCase()) {
            case 'integer':
                return <FormControl type='number' value={value} onChange={(e) => { //To Do Fix culture issues, such as comma vs dot decimal separator.
                    setValue(e.target.value)
                    if(!isNaN(e.target.valueAsNumber))
                        setNewValue(Math.trunc(e.target.valueAsNumber))
                }}/>
            case 'decimal':
                return <FormControl type='number' value={value} step={'0.1'} onChange={(e) => { //To Do Fix culture issues, such as comma vs dot decimal separator.
                    setValue(e.target.value)
                    if(!isNaN(e.target.valueAsNumber))
                        setNewValue(e.target.valueAsNumber)
                }}/>
            case 'boolean':
                return <Form.Switch
                            checked={value}
                            onChange={(e) => {setValue(e.target.checked); setNewValue(e.target.checked)}}
                        />
            case 'timespan':
                return <TimespanInput value={value} setValue={setValue} setNewValue={setNewValue}
                                      constraints={constraints} onValidChange={(valid) => isValid.current = valid}/>

            default: //String and all other types
                return <FormControl type='text' value={value} onChange={(e) => {
                    setValue(e.target.value)
                    setNewValue(e.target.value)
                }}/>
        }
    }

    const ResetToDefaultButton = () => {

        if(!setting.defaultValue || value == setting.defaultValue) // Use == to allow for type coercion
            return null;

        return <InfoIcon text={t('pages.settings.resetToDefault')}
                         iconOptions={{icon: faArrowRotateLeft, color: '#bbbbbb', transform: 'shrink-3'}}
                         onClick={() => {
                            setValue(setting.defaultValue)
                            setNewValue(setting.defaultValue)
                         }}
                         style={{
                             padding: '0.5px 2px',
                             borderRadius: 5,
                             cursor: 'pointer',
                             border: '1px solid #bbbbbb',
                             marginLeft: '0.1rem'
                        }}/>
    }

    return (
        <Form.Group className={'w-100'}>
            <Row>
                <Col className='d-flex flex-column justify-content-center' sm={8}>
                    <FormLabel className='ps-0 mb-0'>{setting.displayName} <ResetToDefaultButton/></FormLabel>
                    {setting.description && <p className={'ms-0 text-muted mb-1'}>{setting.description}</p>}
                </Col>
                <Col className='d-flex align-items-center'>
                    {getInputForType(setting.type)}
                </Col>

            </Row>
        </Form.Group>
    );
};

Setting.defaultProps = {
    onChange: () => {}
}

export default Setting;